module.exports = __webpack_public_path__ + "img/home_icon.c0b4d2e7.png";